import React, { useState } from 'react'
import { Tabs, Typography, Card, Row, Divider, Tooltip, Flex, Space } from 'antd'
import ResultCard from '../../../../../../components/ResultCard'
import eye from "../../../../../../assets/Icons/eye black.png"
import hand from "../../../../../../assets/Icons/hand black.png"
import beam from "../../../../../../assets/Icons/beam black.png"
// import { ANSILaserClassResults } from '../../../../../components/AELTab/ANSI/ANSILaserClassResults'
// import {EyewearResults} from '../../ResultComponents/EyewearResults'
// import { Eyewear } from '../../../../../components/TestAndLabelLinks'
// import LaserClassVerdict from '../../Results/MPE_AEL_Results/LaserClassVerdict'
// import { AllAELANSI } from '../../../../../components/AELTab/ANSI/AllAELANSI'
import { AllAELANSI } from '../../../../../../components/AELTab/ANSI/AllAELANSI'
import { EyewearResults } from '../../../ResultComponents/EyewearResults'
import { Eyewear } from '../../../../../../components/TestAndLabelLinks'
import { Infograph } from '../../../../../../components/infographicsModal/Infograph'
import { EyewearResultsANSI } from '../../../ResultComponents/EyewearResultsANSI'

export function ResultFORepetitivelyPulsedSM_ANSI(props) {
  const textCenter = props.textCenter
  let message = "The LB number indicates the level of protection provided by glass/plastic. ".concat((props.result.Glass != null && props.result.Plastic != null) ? "" : "If the pulse duration exceeds the exposure duration specified in Table B.1, a scale number for I is not applicable, and only a scale number for the D mode should be computed accordingly.")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [info, setInfo] = useState(null)

  const handleClick = (e) => {
    setIsModalOpen(true)
    setInfo(e)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (

    <Tabs items={[{
      key: 1,
      label: "MPE Details",
      children: <>
        <Infograph
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          handleCancel={handleCancel}
          info={info}
        />

        <Card style={{ marginBottom: "20px" }}>
          <Divider> <h4><img src={eye} width={50} style={{ marginRight: "5px" }} /><strong>EYE</strong></h4></Divider>
          <Card style={{
            backgroundColor: (() => {
              if (props.result.MPE.mostRestrictive === props.result.MPE.pulseTrain.num &&
                props.result.MPE.mostRestrictive === props.result.MPE.single.result.mpeStandard.num)
                return "#fcf151"
            })()
          }}>
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Single Pulse MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.MPE?.single?.result?.mpeStandard?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                          } else if (props.units === 'watts') {
                            return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                          }
                        })()} */}

                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.AE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Eye Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.safetyRatio.single_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.safetyRatio.single_num <= 1 && props.result.safetyRatio.single_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.safetyRatio.single_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.safetyRatio.single_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>

          </Card>

          <Card style={{
            backgroundColor: (() => {
              if (props.result.MPE.mostRestrictive === props.result.MPE.pulseTrain.num &&
                props.result.MPE.mostRestrictive === props.result.MPE.single.result.mpeStandard.num) {
                return null
              }
              else if (props.result.MPE.mostRestrictive === props.result.MPE.pulseTrain.num &&
                props.result.MPE.mostRestrictive !== props.result.MPE.single.result.mpeStandard.num) {
                return "#fcf151"
              }
            })()
          }}>
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Pulse Train MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.MPE?.pulseTrain?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                          }
                        })()} */}
                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.AE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Eye Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.safetyRatio.train_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.safetyRatio.train_num <= 1 && props.result.safetyRatio.train_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.safetyRatio.train_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.safetyRatio.train_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>
          </Card>
          <Card style={{
            backgroundColor: (() => {
              if (props.result.MPE.mostRestrictive === props.result.MPE.average.num &&
                props.result.MPE.mostRestrictive === props.result.MPE.single.result.mpeStandard.num &&
                props.result.MPE.mostRestrictive === props.result.MPE.pulseTrain.num) {
                return "null"
              }
              else if (props.result.MPE.mostRestrictive === props.result.MPE.average.num &&
                props.result.MPE.mostRestrictive !== props.result.MPE.single.result.mpeStandard.num &&
                props.result.MPE.mostRestrictive !== props.result.MPE.pulseTrain.num) {
                return "#fcf151"
              }
            })()
          }}
          >
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Average MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.MPE?.average?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.average.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.MPE.average.wattsPerSqmPretty;
                          }
                        })()} */}
                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.AE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Eye Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.safetyRatio.average_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.safetyRatio.average_num <= 1 && props.result.safetyRatio.average_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.safetyRatio.average_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.safetyRatio.average_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>
          </Card>
          <Card style={{
            backgroundColor: (() => {
              if (props.result.safetyRatio.num > 1) {
                return "#d82424"
              }
              else if (props.result.safetyRatio.num <= 0.5) {
                return "#10c96d"
              }
              else if (props.result.safetyRatio.num > 0.5 || props.result.safetyRatio.num <= 1) {
                return "#ffa200"
              }
            })()
          }}>
            <Typography style={textCenter}>
              <strong style={{ color: "#ffffff" }}>
                {(() => {
                  if (props.result.safetyRatio.num > 1) {
                    return "The configuration that has been entered is Dangerous for the Eye! "
                  }
                  else if (props.result.safetyRatio.num <= 0.5) {
                    return "The configuration that has been entered is Safe for the Eye! "
                  }
                  else if (props.result.safetyRatio.num > 0.5 || props.result.safetyRatio.num <= 1) {
                    return "The configuration that has been entered is Marginally Safe for the Eye! "
                  }
                })()}
                {props.result.safetyRatio.pretty} x MPE
              </strong>
            </Typography>
          </Card>
        </Card>

        <Card style={{ marginBottom: "20px" }}>
          <Divider><h4><img src={hand} width={50} style={{ marginRight: "5px" }} /><strong> SKIN </strong> </h4></Divider>

          <Card style={{
            backgroundColor: (() => {
              if (props.result.skinMPE.mostRestrictive === props.result.skinMPE?.pulseTrain?.num &&
                props.result.skinMPE.mostRestrictive === props.result.skinMPE?.single?.result?.mpeStandard?.num)
                return "#fcf151"
            })()
          }}>
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Single Pulse MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.skinMPE?.single?.result?.mpeStandard?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                          } else if (props.units === 'watts') {
                            return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                          }
                        })()} */}

                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.mpe?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.skinMPE?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.skinAE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Skin Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.skinSafetyRatio.single_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.skinSafetyRatio.single_num <= 1 && props.result.skinSafetyRatio.single_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.skinSafetyRatio.single_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.skinSafetyRatio.single_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>

          </Card>

          <Card style={{
            backgroundColor: (() => {
              if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.pulseTrain?.num &&
                props?.result.skinPE?.mostRestrictive === props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                return null
              }
              else if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.pulseTrain?.num &&
                props?.result?.skinMPE?.mostRestrictive !== props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                return "#fcf151"
              }
            })()
          }}>
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Pulse Train MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.skinMPE?.pulseTrain?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                          }
                        })()} */}
                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.skinMPE?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.skinMPE?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.skinAE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Skin Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.skinSafetyRatio.train_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.skinSafetyRatio.train_num <= 1 && props.result.skinSafetyRatio.train_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.skinSafetyRatio.train_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.skinSafetyRatio.train_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>
          </Card>
          <Card style={{
            backgroundColor: (() => {
              if (props.result.skinMPE.mostRestrictive === props.result.skinMPE.average.num &&
                props.result.skinMPE.mostRestrictive === props.result.skinMPE.single.result.mpeStandard.num &&
                props.result.skinMPE.mostRestrictive === props.result.skinMPE.pulseTrain.num) {
                return "null"
              }
              else if (props.result.skinMPE.mostRestrictive === props.result.skinMPE.average.num &&
                props.result.skinMPE.mostRestrictive !== props.result.skinMPE.single.result.mpeStandard.num &&
                props.result.skinMPE.mostRestrictive !== props.result.skinMPE.pulseTrain.num) {
                return "#fcf151"
              }
            })()
          }}
          >
            <Flex justify="space-evenly" wrap="wrap">
              <Space direction="vertical">
                <strong style={textCenter}>
                  Average MPE
                </strong>
                <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                  <Typography style={textCenter}>
                    {props?.result?.skinMPE?.average?.pretty}
                    {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.MPE.average.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.MPE.average.wattsPerSqmPretty;
                          }
                        })()} */}
                  </Typography>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Accessible Emission
                </strong>
                <Space>
                  <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.skinMPE?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty.eng}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                  <Divider type="vertical" style={{ height: "40px" }}></Divider>
                  <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                    <strong>
                      <Typography style={textCenter}>
                        {props?.result?.skinMPE?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.actual_wattsPerSqmPretty.eng}W` : `${props?.result?.skinAE?.actual_joulesPerSqmPretty.eng}J/cm²`}

                        {/* {(() => {
                              if (props.units === 'joules') {
                                return props.result.AE.actual_joulesPerSqmPretty;
                              } else if (props.units === 'watts') {
                                return props.result.AE.actual_wattsPerSqmPretty;
                              }
                            })()} */}
                      </Typography>
                    </strong>
                  </Tooltip>
                </Space></Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Skin Safety Ratio
                </strong>
                <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                  <strong style={props.result.skinSafetyRatio.average_num > 1 ? {
                    ...textCenter,
                    color: "#d82424"
                  } : props.result.skinSafetyRatio.average_num <= 1 && props.result.skinSafetyRatio.average_num >= 0.5 ? {
                    ...textCenter,
                    color: "#ffa200"
                  } : props.result.skinSafetyRatio.average_num < 0.5 ? {
                    ...textCenter,
                    color: "#10c96d"
                  } : null}>
                    {props.result.skinSafetyRatio.average_pretty}
                  </strong>
                </Tooltip>
              </Space>
              <Space direction="vertical">
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </Space>
            </Flex>
          </Card>
          <Card style={{
            backgroundColor: (() => {
              if (props.result.skinSafetyRatio.num > 1) {
                return "#d82424"
              }
              else if (props.result.skinSafetyRatio.num <= 0.5) {
                return "#10c96d"
              }
              else if (props.result.skinSafetyRatio.num > 0.5 || props.result.skinSafetyRatio.num <= 1) {
                return "#ffa200"
              }
            })()
          }}>
            <Typography style={textCenter}>
              <strong style={{ color: "#ffffff" }}>
                {(() => {

                  if (props.result.skinSafetyRatio.num > 1) {
                    return "The configuration that has been entered is Dangerous for the Skin! "
                  }
                  else if (props.result.skinSafetyRatio.num <= 0.5) {
                    return "The configuration that has been entered is Safe for the Skin! "
                  }
                  else if (props.result.skinSafetyRatio.num > 0.5 || props.result.skinSafetyRatio.num <= 1) {
                    return "The configuration that has been entered is Marginally Safe for the Skin! "
                  }
                })()}
                {props.result?.skinSafetyRatio?.pretty} x MPE
              </strong>
            </Typography>
          </Card>
        </Card>
        <Card>
          <Divider orientation="center">
            <h4><img src={beam} width={50} /> <strong>BEAM PROPERTIES</strong></h4>
          </Divider>
          <Flex justify="center" gap="middle" wrap="wrap">
            <ResultCard >
              <div onClick={() => { handleClick("NOHD") }} style={{ cursor: "pointer" }}>
                <strong style={{ ...textCenter }}>
                  N.O.H.D.
                </strong>
                <Tooltip title={"Distance from the output aperture beyond which the beam irradiance or radiant exposure remains below the appropriate corneal maximum permissible exposure."}>
                  <Typography style={textCenter}>
                    {props.result?.NOHD?.eng ?? props.result?.NOHD}m
                    {/* {props.result.NOHD.value} */}
                  </Typography>
                </Tooltip>
              </div>
            </ResultCard>
            <ResultCard>
              <div onClick={() => { handleClick("ENOHD") }} style={{ cursor: "pointer" }}>
                <strong style={textCenter}>
                  E.N.O.H.D.
                </strong>
                <Tooltip
                  // title={"The distance from a laser over which the MPE for the eye may be exceeded, taking into account the possible use of magnifying instruments like telescopes and binoculars."}
                  title={props.result.ENOHD === 0 ? ("ENOHD only applies to wavelengths between 302.5nm ~ 4000nm") : ("The distance from a laser over which the MPE for the eye may be exceeded, taking into account the possible use of magnifying instruments like telescopes and binoculars.")}
                >
                  <Typography style={textCenter}>
                    {props.result.ENOHD === 0 ? ("N/A") : (
                      props.result?.ENOHD?.eng + "m" ?? "N/A"
                    )}
                  </Typography>
                </Tooltip>
              </div>
            </ResultCard>

            <ResultCard>
              <div onClick={() => { handleClick("Spot Size") }} style={{ cursor: "pointer" }}>
                <Space direction="vertical" style={{
                  height: "100%"
                }}>
                  <strong style={textCenter}>
                    Spot Size
                  </strong>
                  <Tooltip title={"The diameter of the beam at the target distance."}>
                    {/* <Typography style={textCenter}>
                        {(() => {
                          if (props.result.laserOperation === 'cw')
                            return props.result.outputBeamDiameter.outputBeamDiameterPretty;
    
                        })()}
    
                      </Typography> */}
                    <Typography style={textCenter}>
                      {props?.result?.outputBeamDiameter}
                    </Typography>
                  </Tooltip>
                </Space>
              </div>
            </ResultCard>
            <ResultCard>
              <div onClick={() => { handleClick("limit aperture") }} style={{ cursor: "pointer" }}>
                <strong style={textCenter}>
                  Limit Aperture
                </strong>
                <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                  <Typography style={textCenter}>
                    Eye: {props.result?.limitAperture?.eye} mm
                  </Typography>
                  <Typography style={textCenter}>
                    Skin: {props.result?.limitAperture?.skin} mm
                  </Typography>
                </Tooltip>
              </div>
            </ResultCard>
            <ResultCard>
              {/* <div onClick={() => { handleClick("beam divergence") }} style={{cursor:"pointer"}}> */}
              <Tooltip title={'The angular measure of the increase in beam diameter with distance from which the beam emerges.'}>
                <strong style={textCenter}>  Beam Divergence</strong>
                <Typography style={textCenter}>
                  {props.result?.beamDivergence}
                </Typography>
              </Tooltip>
              {/* </div> */}
            </ResultCard>

            <ResultCard>
              <div onClick={() => { handleClick("applicable beam area") }} style={{ cursor: "pointer" }}>
                <Tooltip title={'Area of the spot size or limit aperture - whichever is the largest.'}>
                  <strong style={textCenter}>
                    Applicable Beam Area
                  </strong>

                  <Typography style={textCenter}>

                    {`Eye: ${props.result?.applicableBeamArea?.prettiest}`}

                  </Typography>

                  <Typography style={textCenter}>
                    {`Skin: ${props.result?.skinApplicableBeamArea?.prettiest}`}
                    {/* Skin: {(() => {
                        if (props.result.laserOperation === 'singlePulse')
                          return props.result?.skinApplicableBeamArea?.prettiest;
                      })()} */}
                  </Typography>
                </Tooltip>
              </div>
            </ResultCard>

            <ResultCard style={{ width: "200px", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div onClick={() => { handleClick("spectrum") }} style={{ cursor: "pointer" }}>
                <strong style={textCenter}>
                  Spectrum
                </strong>
                <Row justify={"center"}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    backgroundColor: (() => {
                      if (props.result.spectrum.range == "Infrared") {
                        return "maroon"
                      }
                      else if (props.result.spectrum.range == "Ultraviolet") {
                        return "purple"
                      }
                      return "rgb(" + props.result.spectrum.rgb + ")"
                    })(),
                    borderRadius: 100,
                    ustifyContent: "center"
                  }}></div></Row>
                <Row justify={"center"}>{props.result.spectrum.region}</Row>
              </div>
            </ResultCard>
          </Flex>
        </Card>
      </>
    }, {
      key: 2,
      label: "More Information",
      children: <>
        <Row align="center" justify="center">
          <Divider orientation="center">
            Correction Factors & Time Bases
          </Divider>
          {Object.entries(props.result?.correctionFactors || {}).map(([key, cf]) => {
            if (cf.num !== null) {
              return (
                <ResultCard key={key}>
                  <strong style={textCenter}>
                    {key}
                  </strong>
                  <Typography>{cf.pretty}</Typography>
                </ResultCard>
              );
            }
          })}
        </Row>
      </>
    }, {
      key: 3,
      label: "Laser Class Details",
      children:
        <>
          <Row justify="space-evenly">
            <Divider orientation="center">
              Accessible Emission Limits
            </Divider>
            <AllAELANSI props={props} />

          </Row>



          {/* <Tabs defaultActiveKey="1" centered items={[
        {
          key: 1,
          label: "Overall",
          children: <>
          </>
        }, {
          key: 2,
          label: "Time Base",
          children: <>
            <Row justify="space-evenly">
              {props.result.AELresults.map(result => <Card style={{
                margin: 5
              }} block title={`Class ${result.laserClass}`}>
                <Row justify="space-evenly">
                  <Space direction="vertical">
                    {result.AELT.joulesPretty !== null && result.AELT.wattsPretty !== null ? <>
                      <p style={{
                        display: "flex",
                        justifyContent: "center"
                      }}>
                        {(() => {
                          if (props.units === 'joules') {
                            return result.AELT.joulesPretty
                          } else if (props.units === 'watts') {
                            return result.AELT.wattsPretty
                          }
                        }
                        )()}
                      </p>
                    </> : <>
                      <Typography style={textCenter}>
                        N/A
                      </Typography>
                    </>}
                  </Space>
                </Row>
              </Card>)}
            </Row>
    
            <Divider />
    
            {/* LSPC-like shit. */}
          {/* <Row style={{
              justifyContent: "start"
            }}><p style={{
              fontSize: "12px",
              color: "#666666"
            }}>*Note: These results are based on the time base found in 4.3e of IEC60825 standard. </p></Row></>
        }, {
          key: 3,
          label: "Custom Time Base",
          children: <>
            <Row justify="space-evenly">
              {props.result.AELresults.map(result => <Card style={{
                margin: 5
              }} block title={`Class ${result.laserClass}`}>
                <Row justify="space-evenly">
                  <Space direction="vertical">
                    {result.AELTcustom.joulesPretty !== null && result.AELTcustom.wattsPretty !== null ? <>
                      <p style={{
                        display: "flex",
                        justifyContent: "center"
                      }}>
                        {(() => {
                          if (props.units === 'joules') {
                            return result.AELTcustom.joulesPretty
                          } else if (props.units === 'watts') {
                            return result.AELTcustom.wattsPretty
                          }
                        }
                        )()}
                      </p>
                    </> : <>
                      <Typography style={textCenter}>
                        N/A
                      </Typography>
                    </>}
                  </Space>
                </Row>
              </Card>)}
            </Row>
            <Row style={{
              justifyContent: "start"
            }}><p style={{
              fontSize: "12px",
              color: "#666666"
            }}>*Note: These results are based on user input exposure duration. </p></Row></>
        }
      ]} /> */}

        </>
    }, {
      key: 4,
      label: "Laser Protective Eyewear",
      children: <>

        {/* <EyewearResults props={props} /> */}
        <EyewearResultsANSI props={props} />


        <Row justify={'center'}>
          <Eyewear />
        </Row>
      </>
    }]} />
  );
}
